module.exports = __webpack_public_path__ + "img/2.7f48ef6f.png";